"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Spinner_1 = __importDefault(require("../Spinner/Spinner"));
const styled_1 = __importDefault(require("../utils/styled"));
const Container = styled_1.default("div")({
    display: "flex",
    alignItems: "flex-start",
    border: "1px solid",
    wordWrap: "break-word",
    hyphens: "auto",
    wordBreak: "break-all",
}, ({ theme }) => ({
    background: theme.color.background.lighter,
    borderColor: theme.color.background.light,
    padding: theme.space.medium,
    borderRadius: theme.borderRadius,
    fontSize: theme.font.size.body,
    fontWeight: theme.font.weight.medium,
    lineHeight: theme.font.lineHeight,
    color: theme.color.text.lighter,
}));
const Content = styled_1.default("div")({ flexGrow: 1 });
const SpinnerContainer = styled_1.default("div")({
    justifySelf: "flex-end",
    marginTop: 4,
}, ({ theme }) => ({
    marginLeft: theme.space.small,
}));
const InfoPanel = ({ children, loading }) => (React.createElement(Container, null,
    React.createElement(Content, null, children),
    loading && (React.createElement(SpinnerContainer, null,
        React.createElement(Spinner_1.default, null)))));
InfoPanel.defaultProps = {
    loading: false,
};
exports.default = InfoPanel;
//# sourceMappingURL=InfoPanel.js.map